import './styles/Login.scss'
import React, { useEffect, useState, useContext, Suspense } from "react";
import { useNavigate } from 'react-router-dom';
import { AccountContext } from './Accounts.js'
import Globe from './components/Globe/Globe';
import { Canvas } from '@react-three/fiber';
import { CognitoUser } from 'amazon-cognito-identity-js';
import Login from './Login.js';
import StripeContainer from './Stripe.js';
import CheckoutButton from './CheckoutButton.js';
import SignUp from './SignUp.js';
import { useLocation } from 'react-router-dom';

export default function Home(props) {
    const {
        user,
        setUser
    } = props;

    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        if (currentPath === '/signup') {
            setPage(1);
        }
    }, []);

    useEffect(() => {
        if (page == 1) {
            navigate('/signup')
        }
    }, [page]);

    useEffect(() => {
        if (user) {
            navigate('/home');
        }
    }, [user]);

    const pageSwitch = (page) => {
        switch (page) {
            case 0: return <Login user={user} setUser={setUser} setPage={setPage}/>
            case 1: return <SignUp setPage={setPage}/>
            case 2: return <StripeContainer>
                <div>
                    <h1>Welcome to Our Subscription Service</h1>
                    <CheckoutButton priceId="price_1Pb1LOFiQSRJh0rKnMbKj8Bs" />
                </div>
            </StripeContainer>
        } 
    }

    return (
        <div className='login'>
            <div className='login-left'>
                <div className='login-left-globe'>
                    <Canvas className='canvas' camera={{ position: [-3.5,0,0], fov: 60 }}>
                        <Suspense fallback={null}>
                            <Globe/>
                        </Suspense>
                    </Canvas>
                </div>
                <div className='login-left-container'>
                    <div className='login-left-container-logo-container'>
                        <div className='login-left-container-logo'/>
                        <div className='login-left-container-logo-title'>FireWatch</div>
                    </div>
                    <div className='login-left-container-title'>Advanced Wildfire Predictions and Alerts</div>
                    <div className='login-left-container-text'>FireWatch is an innovative application that harnesses the power of artificial intelligence to predict and alert users of potential wildfires. By analyzing complex weather data and real-time satellite imagery, FireWatch provides precise early warnings, enabling proactive measures to safeguard lives, property, and the environment.</div>
                </div>
            </div>
            {pageSwitch(page)}
        </div>
    );
}